const spellsLVL3 = [
  {
    index: 'call-lightning',
    name: 'Call Lightning',
    url: '/api/spells/call-lightning',
    shortdesc:
      'Creates a 60 ft wide cloud 100 ft above the ground that you can send lightning bolts',
    desc: [
      "A storm cloud appears in the shape of a cylinder that is 10 feet tall with a 60-foot radius, centered on a point you can see 100 feet directly above you. The spell fails if you can't see a point in the air where the storm cloud could appear (for example, if you are in a room that can't accommodate the cloud).",
      'When you cast the spell, choose a point you can see within range. A bolt of lightning flashes down from the cloud to that point. Each creature within 5 feet of that point must make a dexterity saving throw. A creature takes 3d10 lightning damage on a failed save, or half as much damage on a successful one. On each of your turns until the spell ends, you can use your action to call down lightning in this way again, targeting the same point or a different one.',
      "If you are outdoors in stormy conditions when you cast this spell, the spell gives you control over the existing storm instead of creating a new one. Under such conditions, the spell's damage increases by 1d10.",
    ],
    higher_level: [
      'When you cast this spell using a spell slot of 4th or higher level, the damage increases by 1d10 for each slot level above 3rd.',
    ],
    range: '120 feet',
    components: ['V', 'S'],
    ritual: false,
    duration: 'Up to 10 minutes',
    concentration: true,
    casting_time: '1 action',
    level: 3,
  },
  {
    index: 'conjure-animals',
    name: 'Conjure Animals',
    url: '/api/spells/conjure-animals',
    shortdesc:
      'Summon fey spirits that take the form of beasts. Choose one of the options:',
    desc: [
      'You summon fey spirits that take the form of beasts and appear in unoccupied spaces that you can see within range. Choose one of the following options for what appears:',
      'One beast of challenge rating 2 or lower',
      'Two beasts of challenge rating 1 or lower',
      'Four beasts of challenge rating 1/2 or lower',
      'Eight beasts of challenge rating 1/4 or lower',
      'Each beast is also considered fey, and it disappears when it drops to 0 hit points or when the spell ends.',
      "The summoned creatures are friendly to you and your companions. Roll initiative for the summoned creatures as a group, which has its own turns. They obey any verbal commands that you issue to them (no action required by you). If you don't issue any commands to them, they defend themselves from hostile creatures, but otherwise take no actions.",
      "The DM has the creatures' statistics.",
    ],
    higher_level: [
      'When you cast this spell using certain higher-level spell slots, you choose one of the summoning options above, and more creatures appear: twice as many with a 5th-level slot, three times as many with a 7th-level.',
    ],
    range: '60 feet',
    components: ['V', 'S'],
    ritual: false,
    duration: 'Up to 1 hour',
    concentration: true,
    casting_time: '1 action',
    level: 3,
  },
  {
    index: 'create-food-and-water',
    name: 'Create Food and Water',
    url: '/api/spells/create-food-and-water',
    shortdesc: 'Create food and water',
    desc: [
      "You create 45 pounds of food and 30 gallons of water on the ground or in containers within range, enough to sustain up to fifteen humanoids or five steeds for 24 hours. The food is bland but nourishing, and spoils if uneaten after 24 hours. The water is clean and doesn't go bad.",
    ],
    range: '30 feet',
    components: ['V', 'S'],
    ritual: false,
    duration: 'Instantaneous',
    concentration: false,
    casting_time: '1 action',
    level: 3,
  },
  {
    index: 'daylight',
    name: 'Daylight',
    url: '/api/spells/daylight',
    shortdesc:
      'A 60-foot-radius sphere of light spreads out from a point you choose within range',
    desc: [
      'A 60-foot-radius sphere of light spreads out from a point you choose within range. The sphere is bright light and sheds dim light for an additional 60 feet.',
      "If you chose a point on an object you are holding or one that isn't being worn or carried, the light shines from the object and moves with it. Completely covering the affected object with an opaque object, such as a bowl or a helm, blocks the light.",
      "If any of this spell's area overlaps with an area of darkness created by a spell of 3rd level or lower, the spell that created the darkness is dispelled.",
    ],
    range: '60 feet',
    components: ['V', 'S'],
    ritual: false,
    duration: '1 hour',
    concentration: false,
    casting_time: '1 action',
    level: 3,
    area_of_effect: {
      type: 'sphere',
      size: 60,
    },
  },
  {
    index: 'dispel-magic',
    name: 'Dispel Magic',
    url: '/api/spells/dispel-magic',
    shortdesc: 'Cancels magical spells and effects',
    desc: [
      "Choose one creature, object, or magical effect within range. Any spell of 3rd level or lower on the target ends. For each spell of 4th level or higher on the target, make an ability check using your spellcasting ability. The DC equals 10 + the spell's level. On a successful check, the spell ends.",
    ],
    higher_level: [
      "When you cast this spell using a spell slot of 4th level or higher, you automatically end the effects of a spell on the target if the spell's level is equal to or less than the level of the spell slot you used.",
    ],
    range: '120 feet',
    components: ['V', 'S'],
    ritual: false,
    duration: 'Instantaneous',
    concentration: false,
    casting_time: '1 action',
    level: 3,
  },
  {
    index: 'plant-growth',
    name: 'Plant Growth',
    url: '/api/spells/plant-growth',
    shortdesc:
      'Make plants grow more. The longer you cast it, the richer the growth',
    desc: [
      'This spell channels vitality into plants within a specific area. There are two possible uses for the spell, granting either immediate or long-term benefits.',
      'If you cast this spell using 1 action, choose a point within range. All normal plants in a 100-foot radius centered on that point become thick and overgrown. A creature moving through the area must spend 4 feet of movement for every 1 foot it moves.',
      "You can exclude one or more areas of any size within the spell's area from being affected.",
      'If you cast this spell over 8 hours, you enrich the land. All plants in a half-mile radius centered on a point within range become enriched for 1 year. The plants yield twice the normal amount of food when harvested.',
    ],
    range: '150 feet',
    components: ['V', 'S'],
    ritual: false,
    duration: 'Instantaneous',
    concentration: false,
    casting_time: '1 action',
    level: 3,
  },
  {
    index: 'protection-from-energy',
    name: 'Protection From Energy',
    url: '/api/spells/protection-from-energy',
    shortdesc:
      'Willing creature you touch has resistance to one damage type of your choice.',
    desc: [
      'For the duration, the willing creature you touch has resistance to one damage type of your choice: acid, cold, fire, lightning, or thunder.',
    ],
    range: 'Touch',
    components: ['V', 'S'],
    ritual: false,
    duration: 'Up to 1 hour',
    concentration: true,
    casting_time: '1 action',
    level: 3,
  },
  {
    index: 'sleet-storm',
    name: 'Sleet Storm',
    url: '/api/spells/sleet-storm',
    shortdesc:
      'Create a 40 ft wide, 20 ft tall cylinder of freezing rain and sleet.',
    desc: [
      'Until the spell ends, freezing rain and sleet fall in a 20-foot-tall cylinder with a 40-foot radius centered on a point you choose within range. The area is heavily obscured, and exposed flames in the area are doused.',
      "The ground in the area is covered with slick ice, making it difficult terrain. When a creature enters the spell's area for the first time on a turn or starts its turn there, it must make a dexterity saving throw. On a failed save, it falls prone.",
      "If a creature is concentrating in the spell's area, the creature must make a successful constitution saving throw against your spell save DC or lose concentration.",
    ],
    range: '150 feet',
    components: ['V', 'S', 'M'],
    material: 'A pinch of dust and a few drops of water.',
    ritual: false,
    duration: 'Up to 1 minute',
    concentration: true,
    casting_time: '1 action',
    level: 3,
    area_of_effect: {
      type: 'cylinder',
      size: 40,
    },
  },
  {
    index: 'speak-with-plants',
    name: 'Speak with Plants',
    url: '/api/spells/speak-with-plants',
    shortdesc:
      'You can temporarily make plants sentient in order to communicate with them or move them.',
    desc: [
      "You imbue plants within 30 feet of you with limited sentience and animation, giving them the ability to communicate with you and follow your simple commands. You can question plants about events in the spell's area within the past day, gaining information about creatures that have passed, weather, and other circumstances.",
      'You can also turn difficult terrain caused by plant growth (such as thickets and undergrowth) into ordinary terrain that lasts for the duration. Or you can turn ordinary terrain where plants are present into difficult terrain that lasts for the duration, causing vines and branches to hinder pursuers, for example.',
      "Plants might be able to perform other tasks on your behalf, at the DM's discretion. The spell doesn't enable plants to uproot themselves and move about, but they can freely move branches, tendrils, and stalks.",
      'If a plant creature is in the area, you can communicate with it as if you shared a common language, but you gain no magical ability to influence it.',
      'This spell can cause the plants created by the entangle spell to release a restrained creature.',
    ],
    range: 'Self',
    components: ['V', 'S'],
    ritual: false,
    duration: '10 minutes',
    concentration: false,
    casting_time: '1 action',
    level: 3,
    area_of_effect: {
      type: 'sphere',
      size: 30,
    },
  },
  {
    index: 'water-breathing',
    name: 'Water Breathing',
    url: '/api/spells/water-breathing',
    shortdesc: 'Up to 10 subjects can breathe underwater',
    desc: [
      'This spell gives a maximum of ten willing creatures within range and you can see, the ability to breathe underwater until the end of its term. Affected creatures also retain their normal breathing pattern.',
    ],
    range: '30 feet',
    components: ['V', 'S', 'M'],
    material: 'A short piece of reed or straw.',
    ritual: true,
    duration: '24 hours',
    concentration: false,
    casting_time: '1 action',
    level: 3,
  },
  {
    index: 'water-walk',
    name: 'Water Walk',
    url: '/api/spells/water-walk',
    shortdesc: 'Lets you walk on water for 1 hour.',
    desc: [
      'This spell grants the ability to move across any liquid surface--such as water, acid, mud, snow, quicksand, or lava--as if it were harmless solid ground (creatures crossing molten lava can still take damage from the heat). Up to ten willing creatures you can see within range gain this ability for the duration.',
      'If you target a creature submerged in a liquid, the spell carries the target to the surface of the liquid at a rate of 60 feet per round.',
    ],
    range: '30 feet',
    components: ['V', 'S', 'M'],
    material: 'A piece of cork.',
    ritual: true,
    duration: '1 hour',
    concentration: false,
    casting_time: '1 action',
    level: 3,
  },
  {
    index: 'wind-wall',
    name: 'Wind Wall',
    url: '/api/spells/wind-wall',
    shortdesc:
      'Creates a wall of wind that can be up to 50 ft long, 15 ft high, and 1 ft thick.',
    desc: [
      'A wall of strong wind rises from the ground at a point you choose within range. You can make the wall up to 50 feet long, 15 feet high, and 1 foot thick. You can shape the wall in any way you choose so long as it makes one continuous path along the ground. The wall lasts for the duration.',
      'When the wall appears, each creature within its area must make a strength saving throw. A creature takes 3d8 bludgeoning damage on a failed save, or half as much damage on a successful one.',
      "The strong wind keeps fog, smoke, and other gases at bay. Small or smaller flying creatures or objects can't pass through the wall. Loose, lightweight materials brought into the wall fly upward. Arrows, bolts, and other ordinary projectiles launched at targets behind the wall are deflected upward and automatically miss. (Boulders hurled by giants or siege engines, and similar projectiles, are unaffected.) Creatures in gaseous form can't pass through it.",
    ],
    range: '120 feet',
    components: ['V', 'S', 'M'],
    material: 'A tiny fan and a feather of exotic origin.',
    ritual: false,
    duration: 'Up to 1 minute',
    concentration: true,
    casting_time: '1 action',
    level: 3,
    damage: {
      damage_type: {
        index: 'bludgeoning',
        name: 'Bludgeoning',
        url: '/api/damage-types/bludgeoning',
      },
      damage_at_slot_level: {
        3: '3d8',
      },
    },
    dc: {
      dc_type: {
        index: 'str',
        name: 'STR',
        url: '/api/ability-scores/str',
      },
      dc_success: 'half',
    },
    area_of_effect: {
      type: 'line',
      size: 50,
    },
  },
];

export default spellsLVL3;
